/**
 * @file 表单列表
 * @description 用于创建、编辑表单时上方的表单
 * /

 /**
 * 表单字段配置对象，定义表单字段的属性和行为。
 * @typedef {Object} FormField
 * @property {string} label - 输入标签，用于显示字段的名称。
 * @property {string} prop - 绑定参数，用于绑定表单数据。
 * @property {string} type - 输入类型，可选值包括：
 *   - input：普通输入框
 *   - select：下拉选择框
 *   - remote：远程搜索框
 * @property {Array<string>} [options] - 下拉选项，仅当 type 为 'select' 或 'remote' 时使用。
 * @property {string} [width] - 输入框宽度，可选，默认为 '100%'。
 * @example
 * const formFields = [
 *   { label: '姓名', prop: 'name', type: 'input' },
 *   { label: '性别', prop: 'gender', type: 'select', options: ['男', '女'] },
 *   { label: '搜索', prop: 'search', type: 'remote' }
 * ];
 */

import { protocolTypeList, deviceTypeList } from './typeList.js'
// 协议编辑表单列表
export const protocolFormList = [
  {
    label: '协议名称',
    prop: 'protocolName',
    type: 'input'
  },
  {
    label: '协议类型',
    prop: 'protocolType',
    type: 'select',
    options: []
  },
  {
    label: '产品类型',
    prop: 'deviceType',
    type: 'select',
    options: []
  },
  {
    label: '协议版本',
    prop: 'protocolVersion',
    type: 'input'
  }
]
// 映射表编辑表单列表
export const valueMappingFormList = [
  {
    label: '表名称',
    prop: 'mappingName',
    type: 'input',
    // width: 200
  },
  {
    label: '内容描述',
    prop: 'mappingContent',
    type: 'input',
    // width: 200
  },
  {
    label: '映射类别',
    prop: 'mappingType',
    type: 'select',
    // width: 200,
    options: []
  }
]
// 测试项编辑表单列表
export const testItemFormList = [
  {
    label: '测试项名称',
    prop: 'testItemName',
    type: 'input'
  },
  {
    label: '测试项描述',
    prop: 'testItemDescription',
    type: 'input'
  },
  {
    label: '协议类型',
    prop: 'protocolType',
    type: 'select',
    options: protocolTypeList
  },
  {
    label: '产品类型',
    prop: 'deviceType',
    type: 'select',
    options: deviceTypeList
  },
  {
    label: '协议名称',
    prop: 'protocolName',
    type: 'remote',
    options: []
  }
]
// 测试用例编辑表单列表
export const testCaseFormList = [
  {
    label: '测试用例名称',
    prop: 'testCaseName',
    type: 'input'
  },
  {
    label: '测试用例描述',
    prop: 'testCaseDescription',
    type: 'input'
  },
  {
    label: '协议类型',
    prop: 'protocolType',
    type: 'select',
    options: protocolTypeList
  },
  {
    label: '产品类型',
    prop: 'deviceType',
    type: 'select',
    options: deviceTypeList
  },
  {
    label: '协议名称',
    prop: 'protocolName',
    type: 'remote'
  }
]
// 端口设置表单列表
export const portSettingFormList = [
  {
    label: '串口名称',
    prop: 'portName',
    type: 'select',
    options: []
  },
  {
    label: '波特率',
    prop: 'baudRate',
    type: 'input'
  },
  {
    label: '数据位',
    prop: 'dataBits',
    type: 'input'
  },
  {
    label: '停止位',
    prop: 'stopBits',
    type: 'input'
  },
  {
    label: '校验位',
    prop: 'parity',
    type: 'select',
    options: [
      {
        label: '无校验',
        value: '0'
      },
      {
        label: '奇校验',
        value: '1'
      },
      {
        label: '偶校验',
        value: '2'
      },
      {
        label: '标记校验',
        value: '3'
      },
      {
        label: '空格校验',
        value: '4'
      }
    ]
  },
  {
    label: '超时时间(ms)',
    prop: 'timeout',
    type: 'input'
  },
  {
    label: '从站地址(十六进制字符串)',
    prop: 'slaveId',
    type: 'input'
  }
]
// 端口设置表单列表(网络接口设备)
export const portSettingFormListNet = [
  {
    label: 'ip地址',
    prop: 'ipAddress',
    type: 'input'
  }
]
